// Drops the fields a form left blank before sending an update.
//
// The edit forms keep "" for every empty input. The API treats "" as "not
// provided" too (EmptyToUndefined on the DTOs), but not sending the key at
// all keeps the request honest: only what the user actually filled travels.
export function omitEmptyStrings<T extends object>(data: T): Partial<T> {
  const out: Partial<T> = {};
  for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
    if (value === '') continue;
    out[key as keyof T] = value as T[keyof T];
  }
  return out;
}
